import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-content-loading',
    template: `
        @if (isLoading) {
            <div
                class="flex min-h-[100px] items-center justify-center py-8"
                [ngClass]="{
                    'justify-center': isCentered,
                    'font-medium': isBold,
                }"
            >
                <app-loading></app-loading>
            </div>
        } @else {
            <ng-content></ng-content>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ContentLoadingComponent {
    @Input() public isLoading = true;
    @Input() public isBold = true;
    @Input() public isCentered = true;
}
